import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      try {
        const hash = location.hash.substring(1);
        const params = new URLSearchParams(hash);
        const sessionId = params.get('session_id');

        console.log('[AuthCallback] Processing session:', sessionId ? 'found' : 'not found');

        if (!sessionId) {
          console.log('[AuthCallback] No session_id, redirecting to login');
          navigate('/login');
          return;
        }

        // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
        console.log('[AuthCallback] Calling /api/auth/session');
        const response = await axios.post(
          `${API}/auth/session`,
          {},
          {
            headers: { 'X-Session-ID': sessionId },
            withCredentials: true
          }
        );
        console.log('[AuthCallback] Session response:', response.data);

        // Store session token in localStorage as backup (use the es_ token from response)
        const sessionToken = response.data.session_token || sessionId;
        localStorage.setItem('session_token', sessionToken);
        console.log('[AuthCallback] Stored session_token:', sessionToken.substring(0, 20) + '...');

        // Session cookie is now set, navigate to home
        console.log('[AuthCallback] Navigating to home');
        window.location.href = '/';
      } catch (error) {
        console.error('[AuthCallback] Auth error:', error);
        navigate('/login');
      }
    };

    processSession();
  }, [location, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="inline-block animate-spin rounded-full h-12 w-12 border-4 border-[#18181B] border-t-transparent"></div>
        <p className="mt-4 text-zinc-500">Autenticando...</p>
      </div>
    </div>
  );
}
